import client from "./client";
import { prepareProductPage } from "./productpage";

export const prepareProductPageThree = prepareProductPage;

export const getProductPageThree = () =>
  client.post("/productpagethree/getPage");
export const addProductPageThree = (payload) =>
  client.post("/productpagethree/addpage", payload);
export const updateProductPageThree = (payload) =>
  client.post("/productpagethree/updatePage", payload);
